import { Skeleton } from '@mint-lib/tw-components';

const ActionCellSkeleton = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <Skeleton variant="circle" className="h-4 w-4" />
    </div>
  );
};

export default ActionCellSkeleton;
